import HELPER from '@/app/utils/HELPER';
import replaceImageToSize from '@/app/utils/replaceImageToSize';

export const useProductCard = () => {
  const transformImgSrc = (image: any) => {
    const expectImageSize = '72x72';
    const src = image ? image.src : HELPER.getDefaultNoImage();
    return replaceImageToSize(src, expectImageSize);
  };

  return { transformImgSrc };
};
